// Connection/reconnection and avatar timing constants for the Voice Live
// training simulation. Extracted from TrainingSimulationVoiceLive so they can
// be shared by the component, its hooks, and pure utilities.

// Reconnection constants
export const RECONNECT_BASE_DELAY = 1000; // 1 second
export const RECONNECT_MAX_DELAY = 30000; // 30 seconds
export const RECONNECT_MAX_RETRIES = 5;
export const ICE_GATHERING_TIMEOUT = 8000; // 8 seconds — relay candidates won't arrive on a 701-blocked network
export const ICE_SERVER_WAIT_TIMEOUT = 8000; // 8 seconds — wait for backend to deliver ICE servers
export const SDP_ANSWER_TIMEOUT = 10000; // 10 seconds — backend typically responds in <2 s; 10 s is ample headroom
export const ICE_CONNECTED_TIMEOUT = 12000; // 12 seconds — give up if ICE stuck in "checking" (e.g. 701 STUN/TURN error)

// Audio-only fallback constants
// When the INITIAL avatar (WebRTC) connection cannot be established, retry the
// peer connection a few times before giving up and switching to an audio-only
// session over the WebSocket. Total initial avatar attempts = 1 + INITIAL_AVATAR_MAX_RETRIES.
export const INITIAL_AVATAR_MAX_RETRIES = 2;
export const AVATAR_PEER_RETRY_DELAY = 1500; // 1.5s between initial avatar peer retries
export const AUDIO_FALLBACK_SAMPLE_RATE = 24000; // PCM16 output sample rate from Azure Voice Live

// Microphone capture retry constants
// On reconnect, the previous connection's mic stream may not have fully
// released at the OS level yet when getUserMedia is re-invoked. A short
// retry absorbs that race instead of tearing down the whole session over
// a transient failure. Total attempts = 1 + MIC_CAPTURE_MAX_RETRIES.
export const MIC_CAPTURE_MAX_RETRIES = 2;
export const MIC_CAPTURE_RETRY_DELAY_MS = 300;
